"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModernPhotoboothCell = exports.ModernPhotobooth = void 0;
var _react = _interopRequireWildcard(require("react"));
var bodyPix = _interopRequireWildcard(require("@tensorflow-models/body-pix"));
var tf = _interopRequireWildcard(require("@tensorflow/tfjs"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _qrcode = _interopRequireWildcard(require("qrcode.react"));
var _axios = _interopRequireDefault(require("axios"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _lodash = require("lodash");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;  // Vertically centers\n  height: 100vh;\n  width: 100vw;\n  position: relative;\n  overflow-y: auto;  // Adds scroll support\n  padding: 1em;\n  box-sizing: border-box;\n"])));
var BackgroundWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-image: url('https://web-treeosk.online/apks/back-ysl.png');\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: 100%;\n"])));
var BackgroundOverlay = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));\n  z-index: 1;\n"])));
var Logo = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 3rem;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 1px;\n  z-index: 2;\n"])));
var PreviewContainer = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;  // Changed from center to flex-start\n  justify-content: center;\n  z-index: 2;\n  transform: ", ";\n"])), function (props) {
  return props.isPreviewStep ? 'translateY(-3rem)' : 'translateY(-3rem)';
});
var Preview = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 24px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0);\n  border: none;\n  margin: '0 auto';\n  border-radius: '24px';\n"])));
var Overlay = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10;\n  left: 6;\n  height: 45rem;\n  width: calc(100% - 2rem);\n  background: ", "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n  border-radius: 24px; /* Match VideoPreview\u2019s border-radius */\n  pointer-events: none; /* Let clicks pass through to the video if needed */\n"])), function (props) {
  return props.filter && "\n    ".concat(props.filter === 'mykonos' ? 'linear-gradient(180deg, rgba(179, 229, 252, 0.9) 0%, rgba(255, 224, 178, 0.9) 50%, rgba(255, 112, 67, 0.9) 100%)' : 'linear-gradient(180deg, rgba(255, 253, 231, 0.9) 0%, rgba(240, 98, 146, 0.9) 50%, rgba(255, 183, 77, 0.9) 100%)', ";\n    mix-blend-mode: normal;\n    opacity: 0.5;\n  ");
});
var CountdownOverlay = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 10rem;\n  height: 10rem;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.2);\n  box-shadow: 10px 15px 30px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px); /* For Safari */\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n"])));
var CountdownNumber = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 6rem;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1;\n"])));
var NavigationBar = _styledComponents.default.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 80px;\n  background: hsla(0, 0.00%, 100.00%, 0.10);\n  backdrop-filter: blur(0px);\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 0 20px;\n  z-index: 2;\n"])));
var NavButton = _styledComponents.default.button(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  opacity: ", ";\n  transition: opacity 0.2s ease;\n\n  &:hover {\n    opacity: 1;\n  }\n"])), function (props) {
  return props.active ? 1 : 0.7;
});
var NavIcon = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var NavLabel = _styledComponents.default.span(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n"])));
var FilterContainer = _styledComponents.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 20px;\n  top: 85%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  z-index: 2;\n"])));
var FilterOption = _styledComponents.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  width: 50px;\n  height: 50px;\n  border-radius: 8px;\n  border: 2px solid ", ";\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &:hover {\n    border-color: #ffffff;\n  }\n"])), function (props) {
  return props.selected ? '#ffffff' : 'rgba(255, 255, 255, 0.3)';
});
var ActionButton = _styledComponents.default.button(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  display: block;\n  color: #000000;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 15rem;\n  padding: 14px 10px;\n  font-size: 1.4rem;\n  margin-top: 1rem;\n  text-transform: uppercase;\n  background: rgba(255, 255, 255, 0.1); /* Transparent white */\n  border: none;\n  box-shadow: none;\n\n"])));
var SecondaryButton = (0, _styledComponents.default)(ActionButton)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  width: 15rem;\n  padding: 14px 10px;\n  font-size: 1rem;\n  margin-top: 1.5rem;\n\n  background: transparent;\n  border: 1.5px solid #000000;\n  box-shadow: none;\n  border-radius: 1rem;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n"])));
var ButtonGroup = _styledComponents.default.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 3rem;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 20px;\n  z-index: 10;\n"])));
var VideoPreview = _styledComponents.default.video(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transform: ", ";\n  background-color: #000;\n  border-radius: 24px;\n"])), function (props) {
  return props.mirror ? 'scaleX(-1)' : 'none';
});
var Canvas = _styledComponents.default.canvas(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: none;\n"])));
var LiveCanvasPreview = _styledComponents.default.canvas(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transform: ", ";\n  background-color: #000;\n  border-radius: 24px;\n  z-index: 2; // Ensure it's above the VideoPreview\n"])), function (props) {
  return props.mirror ? 'scaleX(-1)' : 'none';
});
var GradientCardContainer = _styledComponents.default.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  flex-direction: column;\n  align-items: center;\n  gap: 3em;\n  margin-top: 40px;\n  width: 60%;\n  left: 20%;\n  padding-bottom: 2em;  // Add space for buttons\n"])));
var GradientCard = _styledComponents.default.button(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 10rem;\n  border-radius: 18px;\n  border: solid 6px white;\n  border: none;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.08);\n  background: ", ";\n  cursor: pointer;\n  transition: transform 0.15s;\n  outline: ", ";\n\n  &:hover {\n    transform: scale(1.04);\n  }\n"])), function (_ref6) {
  var gradient = _ref6.gradient;
  return gradient;
}, function (_ref7) {
  var selected = _ref7.selected;
  return selected ? '3px solid #fff' : 'none';
});
var ShareContainer = _styledComponents.default.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: 45% 55%;\n  background: white;\n  border-radius: 24px;\n  overflow: hidden;\n"])));
var PreviewSection = _styledComponents.default.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000;\n"])));
var PreviewImageShare = _styledComponents.default.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  background-image: ", ";\n  background-size: fit-cover;\n  background-position: center;\n  background-repeat: no-repeat;\n"])), function (props) {
  return props.src ? "url(".concat(props.src, ")") : 'none';
});
var FormSection = _styledComponents.default.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  height: 100%;\n  position: relative;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background: white;\n"])));
var ShareFormContainer = _styledComponents.default.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 70vh;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 85%;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  z-index: 10;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.25);\n  border: 0.4rem solid #FFFFFF;\n  box-shadow: 5px 5px 40px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(20px);\n"])));
var ShareForm = _styledComponents.default.form(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"])));
var ShareContent = _styledComponents.default.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 10rem;\n  gap: 0.5rem;\n  align-items: start;\n"])));
var FormTitle = _styledComponents.default.h2(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 1.3rem;\n  font-weight: 500;\n  color: #000;\n  margin: 1rem 0;\n  text-align: center;\n  width: 100%;\n"])));
var QRCodeWrapper = _styledComponents.default.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  background: white;\n  padding: 1rem;\n  border-radius: 0.8rem;\n  width: 8rem;\n  height: 8rem;\n"])));
var QRLabel = _styledComponents.default.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 1rem;\n  color: #000;\n  text-align: center;\n"])));
var ShareInput = _styledComponents.default.input(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  padding: 0.7rem 1rem;\n  border-radius: 2rem;\n  border: 1px solid #E0E0E0;\n  font-size: 1.3rem;\n  font-family: 'Helvetica Neue', sans-serif;\n  outline: none;\n  background: rgba(0, 0, 0, 0.2);\n\n  &:focus {\n    border-color: #000;\n  }\n"])));
var ShareCheckbox = _styledComponents.default.label(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 0.8rem;\n  color: #000;\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  line-height: 1.4;\n\n  input {\n    width: 1rem;\n    height: 1rem;\n  }\n"])));
var ShareButton = (0, _styledComponents.default)(ActionButton)(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  margin: 0;\n  width: 50%;\n  border-radius: 2rem;\n  color: black;\n  font-size: 1.3rem;\n  padding: 1rem;\n  text-transform: none;\n  background: rgba(255, 255, 255, 0.8);\n  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(12.5px);\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n"])));
var QRButton = _styledComponents.default.button(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 16px;\n  border-radius: 8px;\n  background-color: #000;\n  color: white;\n  border: none;\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 1.3rem;\n  cursor: pointer;\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n"])));
var RetourButton = _styledComponents.default.button(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 7rem;\n  left: 8%;\n\n  padding: 0.5rem 1em;\n\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid #000000;\n  border-radius: 10px;\n  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.25);\n\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: #000000;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  z-index: 50;\n\n  opacity: ", ";\n  pointer-events: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.2);\n  }\n"])), function (props) {
  return props.disabled ? 0.5 : 1;
}, function (props) {
  return props.disabled ? 'none' : 'auto';
});
var RetourButtonShare = (0, _styledComponents.default)(RetourButton)(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: transparent;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  color: black;\n  padding: 12px 32px;\n  font-size: 1rem;\n"])));
var FilterPreviewContainer = _styledComponents.default.div(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 6rem;\n  left: 80%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 0.8rem;\n  z-index: 3;\n  align-items: center;\n"])));
var FilterPreviewOption = _styledComponents.default.div(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  border-radius: 8px;\n  border: 2px solid ", ";\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  opacity: ", ";\n  transform: ", ";\n\n  &:hover {\n    opacity: 1;\n    border-color: #ffffff;\n  }\n"])), function (props) {
  return props.selected ? '5rem' : '3rem';
}, function (props) {
  return props.selected ? '5rem' : '3rem';
}, function (props) {
  return props.selected ? '#ffffff' : 'rgba(255, 255, 255, 0.3)';
}, function (props) {
  return props.selected ? 1 : 0.8;
}, function (props) {
  return props.selected ? 'scale(1.1)' : 'scale(1)';
});
var CameraButton = _styledComponents.default.div(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  position: absolute;\n  padding: 3rem;\n  left: 50%;\n  bottom: 4rem;\n  transform: translateX(-50%);\n  background: rgba(255, 255, 255, 0.6);\n  border: 3px solid #FFFFFF;\n  border-radius: 50%;\n  box-shadow: 10px 15px 30px rgba(0, 0, 0, 0.25);\n  -webkit-backdrop-filter: blur(20px); /* Safari support */\n  box-sizing: border-box;\n  z-index: 3;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var CameraText = _styledComponents.default.div(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 1rem;\n  left: 50%;\n  transform: translateX(-50%);\n  color: black;\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 1.2em;\n  font-weight: 500;\n  letter-spacing: 1px;\n  text-align: center;\n"])));
var PreviewWrapper = _styledComponents.default.div(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 1rem;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  /* Enforce portrait aspect ratio */\n  width: auto; /* Let height determine width based on aspect ratio */\n  height: 70vh; /* Maintain vertical height */\n  aspect-ratio: 16 / 9; /* Portrait aspect ratio */\n  max-width: 90%; /* Prevent exceeding screen width */\n  /* margin: 20px auto; Removed margin as fixed positioning handles placement */\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 100; /* Ensure it's above other content */\n"])));
var PreviewWrapper2 = _styledComponents.default.div(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 38%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 1rem;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  /* Enforce portrait aspect ratio */\n  width: auto; /* Let height determine width based on aspect ratio */\n  height: 60vh; /* Maintain vertical height */\n  aspect-ratio: 16 / 9; /* Portrait aspect ratio */\n  max-width: 85%; /* Prevent exceeding screen width */\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 100; /* Ensure it's above other content */\n"])));
var ImageContainer = _styledComponents.default.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: calc(100% - 60px); /* Adjust height considering logo */\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  background-image: url(", ");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  transform: scaleX(-1);\n\n  img {\n    max-width: 100%; /* Ensure image width doesn't exceed container */\n    max-height: 100%; /* Ensure image height doesn't exceed container */\n    width: auto; /* Allow width to adjust based on height */\n    height: 100%; /* Allow height to adjust based on width */\n    object-fit: fit; /* Maintain aspect ratio, fit within bounds */\n    border-radius: 20px;\n    object-fit: cover;\n  }\n"])), function (props) {
  return props.imageUrl;
});
var LogoImage = _styledComponents.default.img(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  height: auto;\n  width: 7rem;\n  margin-top: 0.5rem;\n"])));
var ModernPhotoboothCell = function ModernPhotoboothCell(_ref8) {
  var preview = _ref8.preview,
    cell = _ref8.cell,
    project = _ref8.project;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "photobooth-cell ".concat(preview ? 'preview' : '')
  }, /*#__PURE__*/_react.default.createElement("h3", null, cell.title), /*#__PURE__*/_react.default.createElement("p", null, cell.description), cell.background_image_uri && /*#__PURE__*/_react.default.createElement("img", {
    src: cell.background_image_uri,
    alt: "Photobooth Background"
  }));
};
exports.ModernPhotoboothCell = ModernPhotoboothCell;
var ModernPhotobooth = function ModernPhotobooth(_ref9) {
  var cell = _ref9.cell,
    _ref9$preview = _ref9.preview,
    preview = _ref9$preview === void 0 ? true : _ref9$preview,
    project = _ref9.project,
    _ref9$uriTransformer = _ref9.uriTransformer,
    uriTransformer = _ref9$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref9$uriTransformer;
  var _ref0 = (0, _react.useState)('select'),
    _ref1 = _slicedToArray(_ref0, 2),
    step = _ref1[0],
    setStep = _ref1[1];
  var _ref10 = (0, _react.useState)(null),
    _ref11 = _slicedToArray(_ref10, 2),
    selectedCard = _ref11[0],
    setSelectedCard = _ref11[1];
  var _ref12 = (0, _react.useState)(3),
    _ref13 = _slicedToArray(_ref12, 2),
    countdown = _ref13[0],
    setCountdown = _ref13[1];
  var _ref14 = (0, _react.useState)(null),
    _ref15 = _slicedToArray(_ref14, 2),
    selectedFilter = _ref15[0],
    setSelectedFilter = _ref15[1];
  var _ref16 = (0, _react.useState)(null),
    _ref17 = _slicedToArray(_ref16, 2),
    capturedImage = _ref17[0],
    setCapturedImage = _ref17[1];
  var _ref18 = (0, _react.useState)(false),
    _ref19 = _slicedToArray(_ref18, 2),
    hasCamera = _ref19[0],
    setHasCamera = _ref19[1];
  var _ref20 = (0, _react.useState)(null),
    _ref21 = _slicedToArray(_ref20, 2),
    cameraError = _ref21[0],
    setCameraError = _ref21[1];
  var _ref22 = (0, _react.useState)(''),
    _ref23 = _slicedToArray(_ref22, 2),
    email = _ref23[0],
    setEmail = _ref23[1];
  var _ref24 = (0, _react.useState)(false),
    _ref25 = _slicedToArray(_ref24, 2),
    consent = _ref25[0],
    setConsent = _ref25[1];
  var _ref26 = (0, _react.useState)(false),
    _ref27 = _slicedToArray(_ref26, 2),
    terms = _ref27[0],
    setTerms = _ref27[1];
  var _ref28 = (0, _react.useState)(''),
    _ref29 = _slicedToArray(_ref28, 2),
    link = _ref29[0],
    setLink = _ref29[1];
  var _ref30 = (0, _react.useState)(null),
    _ref31 = _slicedToArray(_ref30, 2),
    animationFrameId = _ref31[0],
    setAnimationFrameId = _ref31[1]; // Added state for animation frame ID

  var videoRef = (0, _react.useRef)(null);
  var canvasRef = (0, _react.useRef)(null);
  var previewCanvasRef = (0, _react.useRef)(null); // For live preview
  var streamRef = (0, _react.useRef)(null);
  var gradients = [{
    id: 'mykonos',
    name: 'MYKONOS',
    gradient: 'linear-gradient(180deg, #b3e5fc 0%, #ffe0b2 50%, #ff7043 100%)'
  }, {
    id: 'sunset',
    name: 'MARRAKECH',
    gradient: 'linear-gradient(180deg, #fffde7 0%, #f06292 50%, #ffb74d 100%)'
  }];

  // Remove the initial useEffect for camera initialization
  // Initialize camera only when entering camera step
  (0, _react.useEffect)(function () {
    if (step === 'camera') {
      console.log('Initializing camera for camera step');
      initializeCamera();
    }

    // Cleanup when leaving camera view
    return function () {
      if (step !== 'camera' && step !== 'countdown') {
        console.log('Cleaning up camera and animation frame');
        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
          setAnimationFrameId(null);
        }
        if (streamRef.current) {
          streamRef.current.getTracks().forEach(function (track) {
            track.stop();
          });
          streamRef.current = null;
        }
        if (videoRef.current) {
          videoRef.current.srcObject = null;
        }
        // Clear the preview canvas
        if (previewCanvasRef.current) {
          var ctx = previewCanvasRef.current.getContext('2d');
          ctx.clearRect(0, 0, previewCanvasRef.current.width, previewCanvasRef.current.height);
        }
        setHasCamera(false);
      }
    };
  }, [step, animationFrameId]); // Added animationFrameId dependency

  var renderLoop = (0, _react.useCallback)(function () {
    if (!videoRef.current || !previewCanvasRef.current || videoRef.current.paused || videoRef.current.ended) {
      setAnimationFrameId(null);
      return;
    }
    var video = videoRef.current;
    var canvas = previewCanvasRef.current;
    var ctx = canvas.getContext('2d');

    // Ensure canvas dimensions match video
    if (canvas.width !== video.videoWidth || canvas.height !== video.videoHeight) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
    }

    // Draw video frame
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Apply filter if selected
    if (selectedFilter) {
      try {
        applyFilterToCanvas(ctx, canvas.width, canvas.height, selectedFilter);
      } catch (error) {
        console.error('Error applying filter in render loop:', error);
        // Optionally reset filter or show an error
      }
    }

    // Request next frame
    var frameId = requestAnimationFrame(renderLoop);
    setAnimationFrameId(frameId);
  }, [selectedFilter]); // Depend on selectedFilter

  var initializeCamera = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var stream, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            // Stop any existing streams and animation first
            if (animationFrameId) {
              cancelAnimationFrame(animationFrameId);
              setAnimationFrameId(null);
            }
            if (streamRef.current) {
              streamRef.current.getTracks().forEach(function (track) {
                return track.stop();
              });
              streamRef.current = null;
            }
            if (videoRef.current) {
              videoRef.current.srcObject = null;
            }
            _context.p = 1;
            console.log('Requesting camera access...');
            _context.n = 2;
            return navigator.mediaDevices.getUserMedia({
              video: {
                width: {
                  ideal: 1920
                },
                height: {
                  ideal: 1080
                },
                facingMode: "user"
              },
              audio: false
            });
          case 2:
            stream = _context.v;
            if (videoRef.current) {
              console.log('Setting up video stream');
              videoRef.current.srcObject = stream;
              videoRef.current.onloadedmetadata = function () {
                console.log('Video metadata loaded');
                videoRef.current.play().then(function () {
                  console.log('Video playing, starting render loop');
                  // Start the render loop only after video is playing
                  if (!animationFrameId) {
                    renderLoop();
                  }
                }).catch(function (e) {
                  return console.error('Error playing video:', e);
                });
              };
              streamRef.current = stream;
              setHasCamera(true);
              setCameraError(null);
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t2 = _context.v;
            console.error('Error accessing camera:', _t2);
            setCameraError(_t2.message);
            setHasCamera(false);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function initializeCamera() {
      return _ref.apply(this, arguments);
    };
  }();
  var applyFilterToCanvas = function applyFilterToCanvas(ctx, width, height, filter) {
    var imageData = ctx.getImageData(0, 0, width, height);
    var data = imageData.data;

    // Updated gradient definitions to match the preview overlay
    var gradients = {
      mykonos: ['rgba(179, 229, 252, 0.9)', 'rgba(255, 224, 178, 0.9)', 'rgba(255, 112, 67, 0.9)'],
      sunset: ['rgba(255, 253, 231, 0.9)', 'rgba(240, 98, 146, 0.9)', 'rgba(255, 183, 77, 0.9)']
    };
    var rgbaToRGB = function rgbaToRGB(rgba) {
      // Extract RGB values and alpha from rgba string
      var match = rgba.match(/rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/);
      if (!match) return [0, 0, 0, 0];
      return [parseInt(match[1]), parseInt(match[2]), parseInt(match[3]), parseFloat(match[4])];
    };
    var getGradientColor = function getGradientColor(gradient, y) {
      var pos = y / height;
      var segment = 1 / (gradient.length - 1);
      var index = Math.floor(pos / segment);
      var ratio = (pos - index * segment) / segment;
      var start = rgbaToRGB(gradient[index]);
      var end = rgbaToRGB(gradient[Math.min(index + 1, gradient.length - 1)]);
      return [start[0] + (end[0] - start[0]) * ratio, start[1] + (end[1] - start[1]) * ratio, start[2] + (end[2] - start[2]) * ratio, start[3] + (end[3] - start[3]) * ratio];
    };

    // Apply the filter with opacity similar to the preview overlay
    if (filter === 'mykonos' || filter === 'sunset') {
      var gradient = gradients[filter];
      for (var y = 0; y < height; y++) {
        var _getGradientColor = getGradientColor(gradient, y),
          _getGradientColor2 = _slicedToArray(_getGradientColor, 4),
          rG = _getGradientColor2[0],
          gG = _getGradientColor2[1],
          bG = _getGradientColor2[2],
          alpha = _getGradientColor2[3];
        for (var x = 0; x < width; x++) {
          var index = (y * width + x) * 4;

          // Apply blend with opacity (similar to mix-blend-mode and opacity in CSS)
          // Using alpha * 0.5 to match the 0.5 opacity from the CSS
          var blendFactor = alpha * 0.3;
          data[index] = Math.min(255, data[index] * (1 - blendFactor) + rG * blendFactor);
          data[index + 1] = Math.min(255, data[index + 1] * (1 - blendFactor) + gG * blendFactor);
          data[index + 2] = Math.min(255, data[index + 2] * (1 - blendFactor) + bG * blendFactor);
        }
      }
    }
    ctx.putImageData(imageData, 0, 0);
  };
  var _capturePhoto = function capturePhoto() {
    if (!videoRef.current || !canvasRef.current) {
      console.error('Video or canvas reference not available');
      return;
    }
    var video = videoRef.current;
    var canvas = canvasRef.current;

    // Wait for video metadata to load
    if (video.readyState !== video.HAVE_ENOUGH_DATA) {
      console.log('Waiting for video data...');
      setTimeout(_capturePhoto, 100);
      return;
    }

    // Set canvas size to match video dimensions
    canvas.width = video.videoWidth || 1920;
    canvas.height = video.videoHeight || 1080;
    console.log('Capturing photo with dimensions:', canvas.width, 'x', canvas.height);
    var ctx = canvas.getContext('2d');

    // Clear canvas before drawing
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw video frame to canvas
    try {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Apply selected filter
      if (selectedFilter) {
        console.log('Applying filter:', selectedFilter);
        applyFilterToCanvas(ctx, canvas.width, canvas.height, selectedFilter);
      }

      // Convert to data URL
      var imageDataUrl = canvas.toDataURL('image/jpeg', 0.9);
      setCapturedImage(imageDataUrl);

      // Stop video tracks after capture
      if (streamRef.current) {
        streamRef.current.getVideoTracks().forEach(function (track) {
          return track.stop();
        });
      }
    } catch (error) {
      console.error('Error capturing photo:', error);
      setCameraError('Failed to capture photo: ' + error.message);
    }
  };

  // Update the filter when changed in preview mode
  (0, _react.useEffect)(function () {
    if (step === 'preview' && capturedImage && selectedFilter) {
      var canvas = canvasRef.current;
      var img = new Image();
      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        applyFilterToCanvas(ctx, canvas.width, canvas.height, selectedFilter);
        setCapturedImage(canvas.toDataURL('image/jpeg', 0.9));
      };
      img.src = capturedImage;
    }
  }, [selectedFilter, step]);
  (0, _react.useEffect)(function () {
    var timer;
    if (step === 'countdown' && countdown > 0) {
      timer = setTimeout(function () {
        return setCountdown(countdown - 1);
      }, 1000);
    } else if (step === 'countdown' && countdown === 0) {
      _capturePhoto();
      setStep('preview');
    }
    return function () {
      return clearTimeout(timer);
    };
  }, [countdown, step]);
  var handleStartCapture = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _t3;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (hasCamera) {
              _context2.n = 5;
              break;
            }
            console.log('Starting capture - initializing camera');
            _context2.p = 1;
            _context2.n = 2;
            return initializeCamera();
          case 2:
            setStep('countdown');
            setCountdown(3);
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t3 = _context2.v;
            console.error('Failed to initialize camera:', _t3);
            setCameraError('Failed to start camera');
          case 4:
            _context2.n = 6;
            break;
          case 5:
            console.log('Starting capture with existing camera');
            setStep('countdown');
            setCountdown(3);
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function handleStartCapture() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleRetake = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            console.log('Handling retake');
            setCapturedImage(null);
            setSelectedFilter(null);

            // Clean up existing camera stream
            if (streamRef.current) {
              streamRef.current.getTracks().forEach(function (track) {
                return track.stop();
              });
              streamRef.current = null;
            }
            if (videoRef.current) {
              videoRef.current.srcObject = null;
            }
            setHasCamera(false);
            setStep('select');
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function handleRetake() {
      return _ref3.apply(this, arguments);
    };
  }();

  // Add near other state declarations
  var _ref32 = (0, _react.useState)(false),
    _ref33 = _slicedToArray(_ref32, 2),
    isSending = _ref33[0],
    setIsSending = _ref33[1];
  var _ref34 = (0, _react.useState)(null),
    _ref35 = _slicedToArray(_ref34, 2),
    sendStatus = _ref35[0],
    setSendStatus = _ref35[1];

  // Replace handleShare function
  // ... existing imports ...
  var handleShare = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
      var captureCardAsImage, completeCardImage, response, record, _t4;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            if (e) {
              e.preventDefault();
            }
            setIsSending(true);
            setSendStatus(null);
            captureCardAsImage = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var cardElement, html2canvas, canvas;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _context4.n = 1;
                      return new Promise(function (resolve) {
                        return setTimeout(resolve, 100);
                      });
                    case 1:
                      cardElement = document.querySelector(".card-container");
                      if (!cardElement) {
                        _context4.n = 4;
                        break;
                      }
                      _context4.n = 2;
                      return Promise.resolve().then(function () {
                        return _interopRequireWildcard(require('html2canvas'));
                      });
                    case 2:
                      html2canvas = _context4.v;
                      _context4.n = 3;
                      return html2canvas.default(cardElement, {
                        useCORS: true,
                        scale: 2,
                        allowTaint: true,
                        backgroundColor: null,
                        imageTimeout: 0
                      });
                    case 3:
                      canvas = _context4.v;
                      return _context4.a(2, canvas.toDataURL('image/jpeg', 0.9));
                    case 4:
                      return _context4.a(2, capturedImage);
                  }
                }, _callee4);
              }));
              return function captureCardAsImage() {
                return _ref5.apply(this, arguments);
              };
            }();
            _context5.p = 1;
            _context5.n = 2;
            return captureCardAsImage();
          case 2:
            completeCardImage = _context5.v;
            _context5.n = 3;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                cell_id: cell.id,
                image: completeCardImage,
                original_image: capturedImage,
                additional_data: {
                  email: email
                },
                email: email,
                consent: consent,
                terms: terms
              })
            });
          case 3:
            response = _context5.v;
            if (response.ok) {
              _context5.n = 4;
              break;
            }
            throw new Error('Upload failed');
          case 4:
            _context5.n = 5;
            return response.json();
          case 5:
            record = _context5.v;
            setSendStatus('success');
            console.log('Photo sent successfully:', record);
            setLink(record.image_uri);
            setEmail('');
            setConsent(false);
            setTerms(false);
            _context5.n = 7;
            break;
          case 6:
            _context5.p = 6;
            _t4 = _context5.v;
            console.error('Error sending photo:', _t4);
            setSendStatus('error');
            storePhotoOffline(capturedImage);
          case 7:
            _context5.p = 7;
            setIsSending(false);
            return _context5.f(7);
          case 8:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 6, 7, 8]]);
    }));
    return function handleShare(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  // Add new function for offline storage
  var storePhotoOffline = function storePhotoOffline(imageData) {
    try {
      var photos = JSON.parse(localStorage.getItem('photoboothPhotos') || '[]');
      photos.push({
        id: Date.now(),
        image: imageData,
        timestamp: new Date().toISOString()
      });
      localStorage.setItem('photoboothPhotos', JSON.stringify(photos));
    } catch (error) {
      console.error('Error storing photo offline:', error);
    }
  };
  var renderContent = function renderContent() {
    switch (step) {
      case 'select':
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            textAlign: 'center',
            height: '100vh'
          }
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: uriTransformer('https://web-treeosk.online/apks/logo-yves-saint-laurent.svg'),
          alt: "YSL Logo",
          style: {
            width: '80%',
            margin: 'auto',
            marginBottom: '20px',
            marginTop: '60px'
          }
        }), /*#__PURE__*/_react.default.createElement(GradientCardContainer, null, gradients.map(function (card) {
          return /*#__PURE__*/_react.default.createElement(GradientCard, {
            key: card.id,
            gradient: card.gradient,
            selected: selectedCard === card.id,
            onClick: function onClick() {
              setSelectedCard(card.id);
              setSelectedFilter(card.id);
              setStep('camera');
            }
          }, /*#__PURE__*/_react.default.createElement("span", {
            style: {
              color: '#fff',
              fontSize: '1.5rem',
              fontWeight: 700,
              textShadow: '0 2px 8px rgba(0,0,0,0.18)'
            }
          }, card.name));
        })));
      case 'camera':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PreviewWrapper, null, /*#__PURE__*/_react.default.createElement(VideoPreview, {
          ref: videoRef,
          autoPlay: true,
          playsInline: true,
          muted: true,
          mirror: true
        }), /*#__PURE__*/_react.default.createElement(Overlay, {
          filter: selectedFilter
        }), /*#__PURE__*/_react.default.createElement(LogoImage, {
          src: uriTransformer('https://web-treeosk.online/apks/logobottom.png')
          // src={uriTransformer('https://web-treeosk.online/apks/logo-yves-saint-laurent.svg')} 
        })), cameraError && /*#__PURE__*/_react.default.createElement("div", {
          style: {
            color: 'white',
            textAlign: 'center',
            padding: '20px'
          }
        }, "Error accessing camera: ", cameraError));
      case 'countdown':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PreviewWrapper, null, /*#__PURE__*/_react.default.createElement(VideoPreview, {
          ref: videoRef,
          autoPlay: true,
          playsInline: true,
          muted: true,
          mirror: true
        }), /*#__PURE__*/_react.default.createElement(Overlay, {
          filter: selectedFilter
        }), /*#__PURE__*/_react.default.createElement(CountdownOverlay, null, /*#__PURE__*/_react.default.createElement(CountdownNumber, null, countdown)), /*#__PURE__*/_react.default.createElement(LogoImage, {
          src: uriTransformer('https://web-treeosk.online/apks/logobottom.png')
          // src={uriTransformer('https://web-treeosk.online/apks/logo-yves-saint-laurent.svg')} 
        })));
      case 'preview':
      case 'filters':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PreviewWrapper, null, /*#__PURE__*/_react.default.createElement(ImageContainer, null, capturedImage && /*#__PURE__*/_react.default.createElement("img", {
          src: capturedImage,
          alt: "Captured Preview"
        })), /*#__PURE__*/_react.default.createElement(LogoImage, {
          src: uriTransformer('https://web-treeosk.online/apks/logobottom.png')
          // src={uriTransformer('https://web-treeosk.online/apks/logo-yves-saint-laurent.svg')} 
        })));
      case 'share':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Preview, {
          step: step
        }, /*#__PURE__*/_react.default.createElement(PreviewWrapper2, {
          className: "card-container"
        }, capturedImage && /*#__PURE__*/_react.default.createElement(ImageContainer, {
          imageUrl: capturedImage
        }), /*#__PURE__*/_react.default.createElement(LogoImage, {
          src: uriTransformer('https://web-treeosk.online/apks/logoYSL.png')
          // src={uriTransformer('https://web-treeosk.online/apks/logo-yves-saint-laurent.svg')} 
        }))), /*#__PURE__*/_react.default.createElement(ShareFormContainer, null, /*#__PURE__*/_react.default.createElement(FormTitle, null, "Recevoir ma photo par email ou scanner le QR code"), /*#__PURE__*/_react.default.createElement(ShareContent, null, /*#__PURE__*/_react.default.createElement(ShareForm, {
          onSubmit: handleShare
        }, /*#__PURE__*/_react.default.createElement(ShareInput, {
          type: "email",
          placeholder: "Email",
          size: 20,
          value: email,
          onChange: function onChange(e) {
            return setEmail(e.target.value);
          },
          required: true
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
          }
        }, /*#__PURE__*/_react.default.createElement(ShareCheckbox, null, /*#__PURE__*/_react.default.createElement("input", {
          type: "checkbox",
          checked: consent,
          onChange: function onChange(e) {
            return setConsent(e.target.checked);
          }
        }), /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: 'black'
          }
        }, "J'ACCEPTE DE RECEVOIR MA PHOTO PAR EMAIL.")), /*#__PURE__*/_react.default.createElement(ShareCheckbox, null, /*#__PURE__*/_react.default.createElement("input", {
          type: "checkbox",
          checked: terms,
          onChange: function onChange(e) {
            return setTerms(e.target.checked);
          }
        }), /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: 'black'
          }
        }, "J'AI LU ET J'ACCEPTE LES CONDITIONS G\xC9N\xC9RALES."))), /*#__PURE__*/_react.default.createElement(ShareButton, {
          onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();
            handleShare(e);
          },
          type: "button",
          disabled: !email || !consent || !terms
        }, "ENVOYER")), /*#__PURE__*/_react.default.createElement(QRCodeWrapper, null, link && /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
          style: {
            width: '8rem',
            height: '8rem'
          },
          value: link
        }))), /*#__PURE__*/_react.default.createElement(RetourButton, {
          style: {
            bottom: '-4rem',
            left: 'auto'
          },
          onClick: function onClick() {
            window.history.back();
          }
        }, "Retour")));
      default:
        return null;
    }
  };
  return /*#__PURE__*/_react.default.createElement(BackgroundWrapper, null, /*#__PURE__*/_react.default.createElement(Container, null, step === 'select' && /*#__PURE__*/_react.default.createElement(Logo, null, /*#__PURE__*/_react.default.createElement("img", {
    src: uriTransformer('https://web-treeosk.online/apks/ysl-logo.png'),
    alt: "YSL Logo",
    style: {
      height: '24px'
    }
  })), /*#__PURE__*/_react.default.createElement(BackgroundOverlay, null), /*#__PURE__*/_react.default.createElement(PreviewContainer, {
    isPreviewStep: step === 'preview' || step === 'filters'
  }, /*#__PURE__*/_react.default.createElement(Preview, {
    step: step,
    isPreviewStep: step === 'preview' || step === 'filters',
    image: capturedImage
  }, renderContent())), /*#__PURE__*/_react.default.createElement(Canvas, {
    ref: canvasRef
  }), step !== 'select' && step !== 'share' && /*#__PURE__*/_react.default.createElement(RetourButton, {
    disabled: step === 'countdown',
    onClick: function onClick() {
      if (step === 'camera' || step === 'preview' || step === 'filters') {
        setStep('select');
      } else if (step === 'share') {
        setStep('preview');
      }
      // Clean up camera if leaving camera view
      if (step === 'camera') {
        if (streamRef.current) {
          streamRef.current.getTracks().forEach(function (track) {
            return track.stop();
          });
          streamRef.current = null;
        }
        if (videoRef.current) {
          videoRef.current.srcObject = null;
        }
        setHasCamera(false);
      }
    }
  }, "Retour"), (step === 'preview' || step === 'filters') && /*#__PURE__*/_react.default.createElement(ButtonGroup, null, /*#__PURE__*/_react.default.createElement(ActionButton, {
    onClick: function onClick() {
      setStep('share');
      handleShare();
    }
  }, "CONTINUER"), /*#__PURE__*/_react.default.createElement(SecondaryButton, {
    onClick: handleRetake
  }, "REPRENDRE LA PHOTO")), step === 'camera' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(FilterPreviewContainer, null, gradients.map(function (filter) {
    return /*#__PURE__*/_react.default.createElement(FilterPreviewOption, {
      key: filter.id,
      selected: selectedFilter === filter.id,
      onClick: function onClick() {
        return setSelectedFilter(filter.id);
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        background: filter.gradient
      }
    }));
  })), /*#__PURE__*/_react.default.createElement(CameraButton, {
    onClick: handleStartCapture
  }, /*#__PURE__*/_react.default.createElement("svg", {
    style: {
      minWidth: '3.5rem',
      minHeight: '3.5rem'
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "lucide lucide-camera-icon lucide-camera"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "13",
    r: "3"
  }))), /*#__PURE__*/_react.default.createElement(CameraText, null, "PRENDRE LA PHOTO"))));
};
exports.ModernPhotobooth = ModernPhotobooth;